import { readObject, writeObject } from "../../../root/punks/utils/storage"

const LAST_TRACKED_ORDER_ID = "_last_tracked_order"

export const saveLastTrackedOrder = (orderId: string) =>
  writeObject(LAST_TRACKED_ORDER_ID, orderId)

export const getLastTrackedOrder = () => readObject(LAST_TRACKED_ORDER_ID)
